export const currencySymbol = "₭"

export const moneyDisplay = (amount?: number): string => {
  return `${currencySymbol}${(amount ?? 0).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`
}